import { Box, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';

const JobRunDetails = () => {
    const completeJobRunDetailsData = useSelector((state) => state?.getJobRunDetails);
    return (
        <Grid>
            {completeJobRunDetailsData?.loading ?
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "300px",
                    }}
                >
                    <CircularProgress color="inherit" />
                </Box>
                :
                <TableContainer component={Paper} style={{ maxWidth: 1100 }}>
                    <Table sx={{ maxWidth: 1100 }} aria-label="simple table">
                        <TableHead sx={{ background: "#f2f2f2" }}>
                            <TableRow>
                                <TableCell>Unique Id</TableCell>
                                <TableCell>Label</TableCell>
                                <TableCell>Remarks</TableCell>
                                <TableCell>Schedule Type</TableCell>
                                <TableCell>Frequency</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Start</TableCell>
                                <TableCell>Ticket Number</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!completeJobRunDetailsData?.data.length && !completeJobRunDetailsData?.loading ?
                                <TableRow>
                                    <TableCell colSpan={8} sx={{ textAlign: 'center', fontWeight: 'bold' }}>No record found</TableCell>
                                </TableRow>
                                :
                                completeJobRunDetailsData?.data?.map((data) => {
                                    return (
                                        <TableRow
                                            sx={{
                                                "&:last-child td, &:last-child th": {
                                                    border: 0,
                                                },
                                            }}
                                        >
                                            <TableCell component="th" scope="row"  sx={{width:'50px'}}>
                                                {data?.runSeqId}
                                            </TableCell>
                                            <TableCell>
                                                {data?.scheduleLabel || "-"}
                                            </TableCell>
                                            <TableCell sx={{width:'180px',wordBreak: "break-all"}}>
                                                {data?.remarks || "-"}
                                            </TableCell>
                                            <TableCell>
                                                {data?.scheduleType || "-"}
                                            </TableCell>
                                            <TableCell >
                                                {data?.frequency || "-"}
                                            </TableCell>
                                            <TableCell>
                                                {data?.status || "-"}
                                            </TableCell>
                                            <TableCell sx={{width:'100px'}}>
                                                {data?.startTsp || "-"}
                                            </TableCell>
                                            <TableCell  sx={{width:'180px'}}>
                                                {data?.ticketId ?
                                                    <span><a href={`${process.env.REACT_APP_MS_DYNAMICS_TICKET_BASE_URL}&id=${data?.ticketId}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{data?.ticketNumber || "-"}</a></span>
                                                    :
                                                    <span>{data?.ticketNumber || "-"}</span>}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </Grid>
    )
}

export default JobRunDetails